<script lang="ts">
  import { focus } from "../actions";
  import { sendLoginEmail, verifyLoginCode } from "../auth";

  const baseUrl = window.location.origin;

  let waitingForCode = $state(false);
  let email = $state("");
  let loginCode = $state("");
  let error = $state("");

  let isValidEmail = $derived(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim()));
  let hasLoginCode = $derived(loginCode.trim().length === 6 && /^\d+$/.test(loginCode.trim()));

  async function sendCode() {
    error = "";
    try {
      await sendLoginEmail(email.trim());
      waitingForCode = true;
    } catch (e) {
      error = e instanceof Error ? e.message : String(e);
    }
  }

  async function loginWithCode() {
    error = "";
    try {
      await verifyLoginCode(loginCode.trim());
      window.location.pathname = `/login/${loginCode.trim()}`;
    } catch (e) {
      error = e instanceof Error ? e.message : String(e);
    }
  }

  function onEnter(ev: KeyboardEvent) {
    if (ev.key !== "Enter") {
      return;
    }
    if (waitingForCode && hasLoginCode) {
      loginWithCode();
    } else if (isValidEmail) {
      sendCode();
    }
  }
</script>

<div class="mb-4 grid gap-2">
  <a class="btn-outline-default text-center" href={`${baseUrl}/auth/ghlogin`}>Login with GitHub</a>
  <a class="btn-outline-default text-center" href={`${baseUrl}/auth/googlelogin`}>Login with Google</a>
</div>

<div class="mb-3 text-center text-gray-500">or</div>

<label for="email" class="mb-1 block font-medium">Email address</label>
<input
  id="email"
  type="email"
  bind:value={email}
  use:focus
  placeholder="you@example.com"
  onkeydown={onEnter}
  class="mb-3 w-full rounded border border-gray-300 px-2 py-2 dark:border-gray-700 dark:bg-gray-800"
/>

{#if waitingForCode}
  <label for="loginCode" class="mb-1 block font-medium">Login code</label>
  <input
    id="loginCode"
    type="text"
    bind:value={loginCode}
    placeholder="123456"
    onkeydown={onEnter}
    class="mb-3 w-full rounded border border-gray-300 px-2 py-2 dark:border-gray-700 dark:bg-gray-800"
  />
  <button type="button" onclick={loginWithCode} disabled={!hasLoginCode} class="mb-2 w-full btn-outline-default">Login</button>
{/if}

{#if error}
  <div class="mb-3 rounded border border-red-200 bg-red-50 px-3 py-2 text-red-700">{error}</div>
{/if}

<button type="button" onclick={sendCode} disabled={!isValidEmail} class="w-full btn-outline-default">
  {waitingForCode ? "Re-send login code" : "Get login code"}
</button>
